var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { Card } from "@irati/ui/src/Layout";
import Flex from "@irati/ui/src/Flex";
export var AdminBlock = styled(Card)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 67%;\n  margin-right: ", ";\n  ", "\n"], ["\n  width: 67%;\n  margin-right: ", ";\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.four;
}, function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.maxWidthMedia.desktop(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 70%;\n  "], ["\n    width: 70%;\n  "])));
});
export var Email = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  overflow: hidden;\n  white-space: normal;\n  text-overflow: ellipsis;\n"], ["\n  overflow: hidden;\n  white-space: normal;\n  text-overflow: ellipsis;\n"])));
export var FlexGrow = styled(Flex)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  flex-grow: 2;\n"], ["\n  flex-grow: 2;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
